import React, { useState, useEffect } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import {
  Layout,
  Menu,
  Breadcrumb,
  Avatar,
  Dropdown,
  message,
  Button
} from 'antd';
import {
  DashboardOutlined,
  UserOutlined,
  SnippetsOutlined,
  FileOutlined,
  PictureOutlined,
  SettingOutlined,
  LogoutOutlined,
  SolutionOutlined ,
  MenuOutlined,
  GlobalOutlined,
  AppstoreOutlined
} from '@ant-design/icons';
import api from '../../services/api'; // ✅ Use configured api

const { Header, Sider, Content, Footer } = Layout;

const AdminLayout = ({ onToggle }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get('/me');  // ✅ call whoami
        if (res?.data?.user?.type !== 'admin') {
          throw new Error('Not an admin');
        }
        setUser(res.data.user);
      } catch (err) {
        message.error('Unauthorized or session expired');
        navigate('/login');
      }
    };
    fetchUser();
  }, [navigate]);

  
  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  const profileMenu = (
    <Menu>
      {/* <Menu.Item key="profile" icon={<UserOutlined />}>Profile</Menu.Item> */}
      {/* <Menu.Item key="settings" icon={<SettingOutlined />}>Settings</Menu.Item> */}
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>Logout</Menu.Item>
    </Menu>
  );

  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: <Link to="/admin/dashboard">Dashboard</Link>,
    },
    {
      key: 'users',
      icon: <UserOutlined />,
      label: 'User Management',
      children: [
        { key: 'all-users', label: <Link to="/admin/users">All Users</Link> },
        { key: 'pending-users', label: <Link to="/admin/users/pending">Pending Approvals</Link> },
        { key: 'suspending-user', label: <Link to="/admin/users/suspending">User Suspend</Link> },
           { key: 'subscribed-users', label: <Link to="/admin/subscribed-users">Subscribed Users</Link> },
      ],
    },

        {
      key: 'categories',
      icon: <SnippetsOutlined />,
      label: 'Categories',
      children: [
        { key: 'all-categories', label: <Link to="/admin/categories">Manage Categories</Link> },

      ],
    },
    {
      key: 'content',
      icon: <FileOutlined />,
      label: 'Content',
      children: [
        { key: 'blogs', label: <Link to="/admin/content">CMS</Link> },
        { key: 'home', label: <Link to="/admin/home">Home Page</Link> },
  { key: 'about', label: <Link to="/admin/about">About Page</Link> },

      ], 
    },

        {
      key: 'plans',
      icon: <PictureOutlined />,
      label: 'Plan',
      children: [
        { key: 'plans', label: <Link to="/admin/plans">Plan Managment</Link> },

      ], 
    },
    {
      key: 'enquireis',
      icon: <AppstoreOutlined />,
      label: 'Enquireis',
      children: [
        { key: 'partners-enquiries', label: <Link to="/admin/business/partners">Partners Enquiries</Link> },
        
        { key: 'skilled-enquiries', label: <Link to="/admin/business/skilled">Skilled Business Enquiries</Link> },

        { key: 'business-enquiries', label: <Link to="/admin/business">Business for slae Enquiries</Link> },
        { key: 'third-party-enquiries', label: <Link to="/admin/business/third-party">3rd Party Enquiries</Link> },
         { key: 'services-enquiries', label: <Link to="/admin/business/services">Services Enquiries</Link> },
        
      ],
    },
    // {
    //   key: 'reports',
    //   icon: <PieChartOutlined />,
    //   label: 'Reports',
    //   children: [
    //     { key: 'sales', label: <Link to="/admin/reports/sales">Sales</Link> },
    //     { key: 'user-activity', label: <Link to="/admin/reports/users">User Activity</Link> },
    //     { key: 'financial', label: <Link to="/admin/reports/financial">Financial</Link> },
    //   ],
    // },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: <Link to="/admin/subscribers">Subscribers</Link>,
    },

        {
      key: 'jobs',
      icon: <SolutionOutlined />,
      label: <Link to="/admin/career">Job Applications</Link>,
    },
      {
      key: 'visit_website',
      icon: <GlobalOutlined />,
      label:  <Link to="/" target="blank">Visit Website</Link>,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} width={250}>
        <div className="logo">{collapsed ? 'SBP' : 'Startup Business Partner'}</div>
        <Menu theme="dark" mode="inline" defaultSelectedKeys={['dashboard']} items={menuItems} />
      </Sider>

      <Layout className="site-layout">
        <Header style={{ background: '#fff', display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />
          <Dropdown overlay={profileMenu} trigger={['click']}>
            <span style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} />
              <span style={{ marginLeft: 8 }}>{user?.name || 'Admin'}</span>
            </span>
          </Dropdown>
        </Header>

        <Content style={{ padding: '20px' }}>
          {/* <Breadcrumb items={[{ title: 'Admin' }, { title: 'Dashboard' }]} /> */}
          <div className="site-content">
            <Outlet />
          </div>
        </Content>

        <Footer style={{ textAlign: 'center' }}>
          Business Portal © {new Date().getFullYear()} - All Rights Reserved
        </Footer>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
